<template>
  <div class="contact">
    <Head></Head>

    <div class="wrap">
      <section class="content">
        <img src="../assets/map.jpg" alt="">
        <h2 class="css1a8429752e20234">湖南红杏林科技有限公司</h2>
        <address class="addr">
          <li>地址：长沙市高新开发区青山路699号湖南省军民融合科技创新产业园6#栋803室</li>
          <li>服务热线：0731-83091730</li>
          <li>热线咨询时间：8:30-18：00（周一至周六）</li>
        </address>
      </section>
    </div>

    <Foot></Foot>
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Foot from '@/components/Foot.vue'

export default {
  name: 'contact',
  components: {
    Head,
    Foot
  }
}
</script>
<style scoped>
.wrap{
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: 190px 0 70px;
  background:#a43b45 url(../assets/about_bg1.jpg) no-repeat center bottom;
  color: #fff;
}
.content{
  width: 1165px;
  margin: 0 auto;
  text-align: center;
}
h2{
  font-weight: bold;
  font-size: 28px;
  margin-top: 70px;
}
.addr{
  margin-top: 40px;
  line-height: 34px;
  font-style: initial;
}
</style>

